var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('base-button', {
    class: _vm.$style.container,
    on: {
      "click": function click($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('base-icon', {
    attrs: {
      "name": "users_subscribers"
    }
  }), _c('div', {
    class: _vm.$style.badge,
    domProps: {
      "textContent": _vm._s(_vm.subscriberCount.active)
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }